import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentProps } from "solid-js";
import { splitProps } from "solid-js";
import { useAuthV2 } from "@/domains/auth/context/auth-provider";
import { cn } from "@/libs/cn";

const containerVariants = cva("mx-auto px-4 lg:px-2 xl:px-0", {
  variants: {
    size: {
      default: "max-w-4xl",
      "6xl": "max-w-6xl",
      "5xl": "max-w-5xl",
      "4xl": "max-w-4xl",
      full: "max-w-full",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

type ContainerSize = VariantProps<typeof containerVariants>["size"];

export const Container = (
  props: ComponentProps<"div"> & { size?: ContainerSize },
) => {
  const [local, rest] = splitProps(props, ["children", "class", "size"]);
  return (
    <div
      class={cn(containerVariants({ size: local.size }), local.class)}
      {...rest}
    >
      {local.children}
    </div>
  );
};

export const ContainerHeader = (props: ComponentProps<"section">) => {
  const [local, rest] = splitProps(props, ["children", "class"]);
  const [authStoreV2] = useAuthV2();
  return (
    <section
      class={cn(local.class, {
        "pt-32": !authStoreV2?.profile?.id,
        "pt-20": authStoreV2?.profile?.id,
      })}
      {...rest}
    >
      {local.children}
    </section>
  );
};
